<template>
  <div class="d-flex align-items-center h-100">
    <div class="container pb-5">
      <img
        src="https://static.vecteezy.com/system/resources/previews/010/856/652/non_2x/no-result-data-document-or-file-not-found-concept-illustration-flat-design-eps10-modern-graphic-element-for-landing-page-empty-state-ui-infographic-icon-etc-vector.jpg"
        class="img-fluid mx-auto d-block"
      />

      <div class="text-center">
        <h4 class="text-secondary">Cotización rápida</h4>
        <p class="text-secondary text-sm">
          Llene el formulario para obtener una vista previa de su cotización.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
img {
  max-width: 200px;
}
</style>
